import React from 'react';
import iconFolder from '../assets/images/folder.svg';
import PortPaoValle from '../assets/images/portfolio.png';

const DownloadButton = () => {
    const buttonStyle = {
        borderRadius: '8px',
        padding: '15px 25px',
        backgroundColor: '#454545',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        display: 'inline-block'
    };

    const hoverStyle = {
        backgroundColor: '#ccc'
    };

    return (
        <a
            href="/CV_Project_Manager_Paola_2024.pdf"
            download
            style={buttonStyle}
            onMouseEnter={(e) => e.target.style.backgroundColor = hoverStyle.backgroundColor}
            onMouseLeave={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
        >
            Ver / Descargar
        </a>
    );
};

const DownloadButton2 = () => {
    const buttonStyle = {
        borderRadius: '8px',
        padding: '15px 25px',
        backgroundColor: '#454545',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        display: 'inline-block'
    };

    const hoverStyle = {
        backgroundColor: '#ccc'
    };

    return (
        <a
            href="/Portafolio_Paola_Valle.pdf"
            download
            style={buttonStyle}
            onMouseEnter={(e) => e.target.style.backgroundColor = hoverStyle.backgroundColor}
            onMouseLeave={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
        >
            Ver / Descargar
        </a>
    );
};


function Testimonials() {
    const containerStyle = {
        textAlign: 'center',
        marginTop: '20px'
    };

    return (
        <article className="content active" data-page="about">
            <header>
                <h2 className="h2 article-title">Portafolio</h2>
            </header>
            <br /><br /><br />
            <section className="blog-posts">
                <ul className="blog-posts-list">
                    <li className="blog-post-item">
                        <a href="CV_Project_Manager_Paola_2024.pdf">
                            <figure className="blog-banner-box">
                                <img src={iconFolder} alt="folder icon" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">Project Manager</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">2024</time>
                                </div>
                                <h3 className="h3 blog-item-title">Curriculum</h3>
                                <p className="blog-text">
                                    Click en el botón para mostrar el contenido.
                                </p>
                                <div style={containerStyle}>
                                    <DownloadButton />
                                </div>
                            </div>
                        </a>
                    </li>
                    <li className="blog-post-item">
                        <a href="/Portafolio_Paola_Valle.pdf">
                            <figure className="blog-banner-box">
                                <img src={PortPaoValle} alt="portafoio pao valle" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">Project Manager</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">2024</time>
                                </div>
                                <h3 className="h3 blog-item-title">Portafolio</h3>
                                <p className="blog-text">
                                    Click en el botón para mostrar el contenido.
                                </p>
                                <div style={containerStyle}>
                                    <DownloadButton2 />
                                </div>
                            </div>
                        </a>
                    </li>

                </ul>
            </section>
        </article>



    );
}

{/*<section className="projects">*/ }
{/*    <ul className="filter-list">*/ }
{/*        <li className="filter-item">*/ }
{/*            <button className="active" data-filter-btn>All</button>*/ }
{/*        </li>*/ }
{/*        <li className="filter-item">*/ }
{/*            <button data-filter-btn>Web design</button>*/ }
{/*        </li>*/ }
{/*        <li className="filter-item">*/ }
{/*            <button data-filter-btn>Applications</button>*/ }
{/*        </li>*/ }
{/*        <li className="filter-item">*/ }
{/*            <button data-filter-btn>Web development</button>*/ }
{/*        </li>*/ }
{/*    </ul>*/ }
{/*    <div className="filter-select-box">*/ }
{/*        <button className="filter-select" data-select>*/ }
{/*            <div className="select-value" data-select-value>Select category</div>*/ }
{/*            <div className="select-icon">*/ }
{/*                <ion-icon name="chevron-down"></ion-icon>*/ }
{/*            </div>*/ }
{/*        </button>*/ }
{/*        <ul className="select-list">*/ }
{/*            <li className="select-item">*/ }
{/*                <button data-select-item>All</button>*/ }
{/*            </li>*/ }
{/*            <li className="select-item">*/ }
{/*                <button data-select-item>Web design</button>*/ }
{/*            </li>*/ }
{/*            <li className="select-item">*/ }
{/*                <button data-select-item>Applications</button>*/ }
{/*            </li>*/ }
{/*            <li className="select-item">*/ }
{/*                <button data-select-item>Web development</button>*/ }
{/*            </li>*/ }
{/*        </ul>*/ }
{/*    </div>*/ }
{/*    <ul className="project-list">*/ }
{/*        <li className="project-item active" data-filter-item data-category="web development">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Finance</h3>*/ }
{/*                <p className="project-category">Web development</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="web development">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Orizon</h3>*/ }
{/*                <p className="project-category">Web development</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="web design">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Fundo</h3>*/ }
{/*                <p className="project-category">Web design</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="applications">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Brawlhalla</h3>*/ }
{/*                <p className="project-category">Applications</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="web design">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">DSM.</h3>*/ }
{/*                <p className="project-category">Web design</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="web design">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">MetaSpark</h3>*/ }
{/*                <p className="project-category">Web design</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="web development">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Summary</h3>*/ }
{/*                <p className="project-category">Web development</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="applications">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Task Manager</h3>*/ }
{/*                <p className="project-category">Applications</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*        <li className="project-item active" data-filter-item data-category="web development">*/ }
{/*            <a href="#">*/ }
{/*                <figure className="project-img">*/ }
{/*                    <div className="project-item-icon-box">*/ }
{/*                        <ion-icon name="eye-outline"></ion-icon>*/ }
{/*                    </div>*/ }
{/*                    <img src={iconProject} alt="design icon" width="40" />*/ }
{/*                </figure>*/ }
{/*                <h3 className="project-title">Arrival</h3>*/ }
{/*                <p className="project-category">Web development</p>*/ }
{/*            </a>*/ }
{/*        </li>*/ }
{/*    </ul>*/ }
{/*</section>*/ }


export default Testimonials;